export default __webpack_public_path__ + "static/char-s-38-zh-Hant-ce1e6d1ae3e4d119cc0a485f4061a78e.webp";